/* eslint-disable */
import React from 'react';
import DevsPop from './DevsPop';
import DevsOptionList from './DevsOptionList';
import p from './devsPop.module.css';
import { AXIS_NAME, axisValues, fmt } from './devsBarModel';

// DevsAxisPopover — the dropdown of one bar axis (Designer · Season · Factory): same list, same counts, same state as in Filters.
export default function DevsAxisPopover({ axis, model, onClose }) {
  const { opts, devFilters, facets, ready, toggle, only, clearAxis, matched } = model;
  const sel = axisValues(devFilters, axis);
  return (
    <DevsPop anchorKey={`dd:${axis}`} kind="dd2" label={AXIS_NAME[axis]} onClose={onClose}>
      <div className={p.ph}><span className={p.pt}>{AXIS_NAME[axis]}</span>{sel.length ? <button type="button" className={p.lnk} onClick={() => clearAxis(axis)}>Clear</button> : <span className={p.pmu}>Any</span>}</div>
      <DevsOptionList axis={axis} name={AXIS_NAME[axis]} options={opts[axis] || []} selected={sel} counts={facets.axes[axis] || {}} ready={ready} onToggle={toggle} onOnly={only} autoFocus={!window.matchMedia("(max-width:760px)").matches} />
      <div className={p.pf}><span className={p.pmu}><b>{ready ? fmt(matched) : '–'}</b> {matched === 1 ? 'dev' : 'devs'}</span><button type="button" className={p.done} onClick={onClose}>Done</button></div>
    </DevsPop>
  );
}
